import React from "react";
import { FaFacebookF } from "react-icons/fa6";
import { FaTwitter, FaYoutube, FaChevronUp } from "react-icons/fa";
import { IoMdArrowForward } from "react-icons/io";
import { FiInstagram } from "react-icons/fi";
import siteLogo from "../../assets/img/whiteLogo.png";
const Footer = () => {
  return (
    <>
      {/* Footer Area Start */}
      <footer className="footer-area bg-black mt-0">
        <div className="container">
          {/* <div
            className="footer-top-2 bg-base p-5 border-radius-bottom-20"
            style={{ justifyContent: "center" }}
          >
            <div
              className="row mobileRow"
              style={{ justifyContent: "space-around" }}
            >
              <div
                className="col-lg-6"
                style={{
                  width: "unset",
                }}
              >
                <div className="media">
                  <div className="media-left me-3">
                    <img src={fotter1} alt="img" />
                  </div>
                  <div className="media-body">
                    <h5 className="text-white">Contacts Info</h5>
                    <p className="text-white mb-0">info@techvoyagelab.com</p>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6"
                style={{
                  width: "unset",
                }}
              >
                <div className="media">
                  <div className="media-left me-3">
                    <img src={fotter2} alt="img" />
                  </div>
                  <div className="media-body">
                    <h5 className="text-white">Opening Hours</h5>
                    <p className="text-white mb-0">Mon-Sat: 10:00AM - 6:00PM</p>
                    <p className="text-white mb-0">Sunday-CLOSED</p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row pd-top-100 footerLinks">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="widget widget_about">
                <div className="thumb">
                  <img
                    src={siteLogo}
                    alt=""
                    style={{ mixBlendMode: "multiply", maxWidth: "150px" }}
                  />
                </div>
                <div className="details">
                  <p>
                    Leading IT company offering comprehensive, end-to-end
                    technology solutions
                  </p>
                  <div className="subscribe mt-4"></div>
                  <ul className="social-media">
                    <li>
                      <a>
                        <FaFacebookF />
                      </a>
                    </li>
                    <li>
                      <a>
                        <FaTwitter />
                      </a>
                    </li>
                    <li>
                      <a>
                        <FiInstagram />
                      </a>
                    </li>
                    <li>
                      <a>
                        <FaYoutube />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" style={{ width: "fit-content" }}>
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">Our Service</h4>
                <ul>
                  <li>
                    <a>
                      <IoMdArrowForward /> Ui Design
                    </a>
                  </li>
                  <li>
                    <a>
                      <IoMdArrowForward /> Web design
                    </a>
                  </li>
                  <li>
                    <a>
                      <IoMdArrowForward /> Digital marketing
                    </a>
                  </li>
                  <li>
                    <a>
                      <IoMdArrowForward /> Video Editing
                    </a>
                  </li>
                  <li>
                    <a>
                      <IoMdArrowForward /> IT Training
                    </a>
                  </li>
                  <li>
                    <a>
                      <IoMdArrowForward /> Web Development
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom bg-base">
          <div className="container">
            <div className="row">
              <div className="col-md-6 align-self-center">
                <p>© Tech Voyage Lab 2024 | All Rights Reserved</p>
              </div>
              <div className="col-md-6 text-lg-end">
                <p>
                  Design and Developed <span style={{ color: "red" }}>❤</span>{" "}
                  Tech Voyage Lab
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* Footer Area End */}

      {/* Back to Top Area Start */}
      <div className="back-to-top">
        <span className="back-top">
          <FaChevronUp />
        </span>
      </div>
      {/* Back to Top Area End */}
    </>
  );
};

export default Footer;
